import React, { useContext } from "react";
import uiContext from "../context/ui/uiContext";
import "../css/MobileNav.css";
import { Link } from "react-router-dom";
import userProfile from "../image/userprofile.svg";
import UserContext from "../context/users/UserContext";

function MobileNav(props) {
  const widthContext = useContext(uiContext);
  const context = useContext(UserContext);
  const handleClick = () => {
    widthContext.setSideBar(0);
  };
  return (
    <div
      className={
        widthContext.sideBar ? "mobilenav mobilenavactive" : "mobilenav"
      }
    >
      <div className="authbox">
        {context.loggedIn ? (
          <>
            <div className="userwrapper">
              <Link to="/dashboard" onClick={handleClick} className="fetched">
                <img src={userProfile} alt="user svg" />
                <span>
                  {context.userDetails.name ? context.userDetails.name : ""}
                </span>
              </Link>
              <Link to="/logout" onClick={handleClick}>
                Logout
              </Link>
            </div>
          </>
        ) : (
          <>
            <Link to="/login" onClick={handleClick}>
              Login
            </Link>
            <Link to="/signup" onClick={handleClick}>
              Signup
            </Link>
          </>
        )}

        {/* <>
        <div className="userwrapper">
        <div className="fetched">
        <img src={userProfile} alt="user svg"/>
        <span>{context.userDetails.name}</span>
        </div>
        <Link to="/logout" onClick={handleClick}>Logout</Link>
        </div>
        </> */}
      </div>
      <div className="authbox">
        <ul>
          <Link to="/" onClick={handleClick}>
            <li>Home</li>
          </Link>
          <Link to="/category/general" onClick={handleClick}>
            <li>General</li>
          </Link>
          <Link to="/category/technology" onClick={handleClick}>
            <li>Technology</li>
          </Link>
          <Link to="/category/sports" onClick={handleClick}>
            <li>Sports</li>
          </Link>
          <Link to="/category/health" onClick={handleClick}>
            <li>Health</li>
          </Link>
          <Link to="/category/movies" onClick={handleClick}>
            <li>Movies</li>
          </Link>
          <Link to="/category/bio" onClick={handleClick}>
            <li>Bio</li>
          </Link>
        </ul>
      </div>
    </div>
  );
}

export default MobileNav;
